/* The site's accent, for the places that need it in JavaScript.

   The value is `$secondary` in `resources/sass/_tokens.scss`, and a SCSS
   variable is not reachable from a script, so the one place the front end needs
   the accent in JS repeats it here rather than inline. That place is the Inertia
   progress bar: the library draws the bar against the top of the window rather
   than through a stylesheet, so handing it the colour is the only way it can
   carry the site's pink. It lives in a module for the same reason
   `hasFinePointer` does: a value two callers would otherwise spell separately
   belongs somewhere they can both reach. */
export const BRAND_ACCENT = '#fd0d6e';
